import React from 'react'
import cssModules from 'react-css-modules'
import styles from './start_your_own.less'
import { getI18n } from 'client/i18n'
import People from '!!babel-loader!react-svg-loader!images/pools_logo.svg' // eslint-disable-line import/no-unresolved
import FadeOutLink from 'components/common/fade_out_link'

const i18n = getI18n('components/start')

class Start extends React.Component {
  render() {
    return (
      <div styleName="start">
        <div styleName="icon">
          <People width="70" height="70" />
        </div>
        <div styleName="title">{i18n('title')}</div>
        <FadeOutLink
          href={`${GLOBAL_CONSTS.REQUEST_URI}/start`}
          className="vx_btn vx_btn-secondary vx_btn-block"
          styleName="create-button"
          data-pa-click="start"
        >
          {i18n('create')}
        </FadeOutLink>
      </div>
    )
  }
}

export default cssModules(Start, styles)
